import React, {useState, useEffect} from 'react';
import { CheckSubscribe } from '../../EventReg/CheckSubscribe';

const OrderedTab = props => {
    const {listener} = props;
    const [listenerArr, setListenerArr] = useState([]);
    const [isButtonAble, setIsButtonAble] = useState(false);
  // console.log('orderedTab, listener: ', listener);
  //   useEffect(() => {
  //     setListenerArr(oldArr => [...oldArr, listener]);
  //   }, []);
    useEffect(() => {
      setListenerArr([listener]);
    }, [listener]);
  return  listenerArr.length > 0 ? listenerArr.map((item) => {
    if (!item.price) return <p className="banner-action__price">Бесплатно</p>;
    if (item.isForEntity && !item.isPaid && item.price)
      return (
        <React.Fragment>
          <p className="banner-action__price">{item.price} руб.</p>
          <p className="banner-action__price">Оплата по счету</p>
        </React.Fragment>
      );
    if (item.price && item.canPay && !item.isPaid && item.rfid) {
      return (
        <React.Fragment>
          <p className="banner-action__price">{item.price} руб.</p>
          <div className="banner-action__btn-offer-wrapper">
            {/* TODO: нужно добавить metrikaGoal('openBill'); */}
            <a
              id={item.rfid}
              className={`btn btn--primary${
                item.isButtonDisabled || !isButtonAble
                  ? ' btn--disabled'
                  : ''
              }`}
              href={`/order/${item.rfid}/`}
            >
              Оплатить
            </a>
          </div>
          {!item.isButtonDisabled && (
            <p className="banner-action__offer">
              <CheckSubscribe
                text={
                  <>
                    Соглашаюсь с условиями {''}
                    <a
                      className="txt--red"
                      target="_blank"
                      rel="noreferrer"
                      href={`/profile/orders/oferta?RFID=${item.rfid}`}
                    >
                      Договора-оферты
                    </a>
                  </>
                }
                onChange={setIsButtonAble}
                isOrderTab
              />
            </p>
          )}
        </React.Fragment>
      );
    }
    if (item.price && item.isPaid)
      return (
        <React.Fragment>
          <p className="banner-action__price">{item.price} руб.</p>
          <p className="banner-action__price">Оплачено</p>
        </React.Fragment>
      );
    if (item.price && !item.canPay)
      return (
        <React.Fragment>
          <p className="banner-action__price">{item.price} руб.</p>
        </React.Fragment>
      );

    return null;
  }): null;
};

export default OrderedTab;
